import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

type AppliedFilterCountProps = {
  inverted?: boolean;
};

export const AppliedFilterCount = styled.span<AppliedFilterCountProps>`
  align-items: center;
  border-radius: 50%;
  background: ${({ inverted, theme }) =>
    inverted ? theme.pill.inverted.bg : theme.pill.primary.bg};
  color: ${({ inverted, theme }) =>
    inverted ? theme.pill.inverted.text : theme.pill.primary.text};
  display: inline-flex;
  font-weight: 600;
  height: 20px;
  justify-content: center;
  margin: 0 ${layout.spacing.xSmall};
  width: 20px;
`;

export const FilterSectionButtonList = styled.div`
  padding: 0 ${layout.spacing.xSmall};
  width: 100%;
`;
